$(document).ready(function() {

    // Rolex carousel
  //modified by kesato
  if( $("#exploring-rolex-carousel").length > 0 ){
    $('#exploring-rolex-carousel').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      responsive: [{
          breakpoint: 720,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
      }]
    });
  }

    // Rolex contact tab
    $('[data-toggle="tab"]').on('click', function(evt) {
        evt.preventDefault();
        var target = $(this).attr('href');
        $('.tab').removeClass('active');
        $(target).addClass('active');
    });
  
});

// When the window has finished loading create our google map below
// google.maps.event.addDomListener(window, 'load', init);


function init() {

    var centerAll = new google.maps.LatLng(46.57595558001309, 7.131897286671404);
    var neuchatel = new google.maps.LatLng(46.99025532112221, 6.929601156393316);
    var verbier = new google.maps.LatLng(46.09530729810565, 7.230910698095158);
    var markerIcon = 'https://cdn.shopify.com/s/files/1/0271/1158/7928/files/store.png';
    
    if (jQuery('#map').data('store') == 'neuchatel') {
        var mapCenter = neuchatel;
        var mapZoom = 16;
        var markers = 'neuchatel';
    
    } else if (jQuery('#map').data('store') == 'verbier') {
        var mapCenter = verbier;
        var mapZoom = 16;
        var markers = 'verbier';

    } else {
        var mapCenter = centerAll;
        var mapZoom = 8;
        var markers = 'all';
    }

    // Basic options for a simple Google Map
    // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
    var mapOptions = {
        // How zoomed in you want the map to start at (always required)
        zoom: mapZoom,

        // The latitude and longitude to center the map (always required)
        center: mapCenter,

        // How you would like to style the map. 
        // This is where you would paste any style found on Snazzy Maps.
        styles: [{"featureType":"all","elementType":"geometry.fill","stylers":[{"weight":"2.00"}]},{"featureType":"all","elementType":"geometry.stroke","stylers":[{"color":"#9c9c9c"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#eeeeee"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#7b7b7b"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#46bcec"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#c8d7d4"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#070707"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]}],

        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
    };

    // Get the HTML DOM element that will contain your map 
    // We are using a div with id="map" seen below in the <body>
    var mapElement = document.getElementById('map');

    // Create the Google Map using our element and options defined above
    var map = new google.maps.Map(mapElement, mapOptions);

    if (markers == 'all' || markers == 'neuchatel') {
        var marker1 = new google.maps.Marker({
            position: neuchatel,
            map: map,
            icon: markerIcon,
            title: "Michaud SA Neuchâtel<br>Pl. Pury 1-3, 2000 Neuchâtel"
        });
    }
    if (markers == 'all' || markers == 'verbier') {
        var marker2 = new google.maps.Marker({
            position: verbier,
            map: map,
            icon: markerIcon,
            title: "Michaud SA Verbier<br>Rue de Médran 5, 1936 Verbier"
        });
    }
    if (markers == 'all') {
        marker1.addListener("click", function() {
            jQuery('#store-neuchatel').show();
            jQuery('#store-verbier').hide();
        });
        marker2.addListener("click", function() {
            jQuery('#store-neuchatel').hide();
            jQuery('#store-verbier').show();
        });
    }
}